import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';

// export const input = {
//   input: {
//     navBgc: base.color.c0023,
//     color: base.color.c0014,
//     inputLabelBg: base.color.c0023,
//     inputBg: comm.color.cffff,
//   },
//   formInput: {
//     color: comm.color.cffff,
//     singInputBg: base.color.c0024,
//     singInputColor: base.color.c0015,
//     inputBg: base.color.c0026,
//   },
// };
const inpTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  inpTheme[item] = {
    input: {
      navBgc: base[item]?.inpColor.c0023,
      color: base[item]?.inpColor.c0014,
      inputLabelBg: base[item]?.inpColor.c0023,
      inputBg: comm.color.cffff,
      inputColor: base[item]?.inpColor.transparent,
      borderColor: base[item]?.inpColor.c0024,
      borderColorNew: base[item]?.inpColor.c0002,
      inputDisBg: comm.color.c0001,
      inputDisColor: comm.color.c0002,
    },
    formInput: {
      color: comm.color.cffff,
      singInputBg: base[item]?.inpColor.c0023,
      singInputColor: base[item]?.inpColor.c0015,
      inputBg: base[item]?.inpColor.c0026,
      inputColor: base[item]?.inpColor.transparent,
      inputContentColor: base[item]?.inpColor.c0014,
    },
  };
}

export const input = inpTheme;
